module.exports = __webpack_public_path__ + "img/en.9b916954.svg";